let mainPath = "/expenses";
let viewFolder = "Expenses";

module.exports = [
    {
        path: "/expenses",
        name: 'expenses',
        component: () => import('../views/'+viewFolder+'/Index.vue'),
    },
    {
        path: mainPath+'/view/:id',
        name: 'expense',
        component: () => import('../views/'+viewFolder+'/View.vue'),
    },
    {
        path: mainPath+'/create/:id',
        name: 'Edit Expense',
        component: () => import('../views/'+viewFolder+'/View.vue'),
    }
]